// extracted by css-extract-rspack-plugin
export default {"cls1":"CoauthorConfirmationCard-cls1_YG5","cls2":"CoauthorConfirmationCard-cls2_8xz CoauthorConfirmationCard-cls1_YG5"};